import { BaseClient } from '@models/clients';
import { SavedPin } from '@models/teranet';
import { Selector } from '@ngxs/store';
import { MatterClients } from '@state/global/matter_clients';
import { SalePinState } from '@state/sale_pins';

export interface SyncInnerFormState {
	parentPins: SavedPin[];
	sellers: BaseClient[];
}

export class SyncInnerFormStateSelector {
	@Selector([SalePinState.getParents, MatterClients.get_owners])
	static getSyncInnerFormState(
		parentPins: SavedPin[],
		sellers: BaseClient[],
	): SyncInnerFormState {
		return {
			parentPins,
			sellers,
		};
	}
}
